import { render, staticRenderFns } from "./DriverUpdateDialog.vue?vue&type=template&id=527a63cb&scoped=true"
import script from "./DriverUpdateDialog.vue?vue&type=script&lang=js"
export * from "./DriverUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverUpdateDialog.vue?vue&type=style&index=0&id=527a63cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a63cb",
  null
  
)

export default component.exports